export const projects = [
    {
        "name": "BotChatAI",
        "keywords": [
            "ML",
            "RASA NLU",
            "spaCy",
            "Flask",
            "ReactJs",
            "MongoDB"
        ],
        "description": "BotChatAI is a Conversational AI and Digital UX Virtual Assistant Platform and Solutions."
    },
    {
        "name": "Versa Titan  (SD-WAN)",
        "keywords": [
            "Python",
            "Django",
            "Djangorestframework 3",
            "ReactJs",
            "MongoDB",
            "Apache Kafka"
        ],
        "description": "Versa Titan is a Cloud Managed SD-WAN & SD-Security solution that provides IT with cloud-agility, simplifying the design, deployment, and operations of WAN. Developing a Network Device with software to control the entire branch network LAN, WAN, Enable security and monitoring. This application will be supporting Multi-language including Arabic language."
    },
    {
        "name": "IoT Engine",
        "keywords": [
            "Django 2",
            "Djangorestframework 3",
            "Python",
            "MongoDB",
            "ReactJs",
            "Apache Kafka",
            "Apache Spark",
        ],
        "description": "IoT Engine will monitor the sensor device process and send an alert every time a problem occurs during this process. Monitoring systems and sensors will help with solving these problems and to make data-informed decisions and take corrective actions to avoid damaging.  The use of sensors will greatly improve the quality and speed of the production process, the same IoT engine will read sensor metrics data and update it into the monitoring system within a short span of time."
    },
    {
        "name": "MODE v2.0",
        "keywords": [
            "Django 1.8",
            "Python",
            "Postgresql",
            "HTML",
            "CSS",
            "jQuery",
            "Java Script",
            "Ajax"
        ],
        "description": "Fashion and media agencies, THE MODE Saas platform is used by world's top fashion and media agencies to manage their digital content."
    },
    {
        "name": "MODE v1.0",
        "keywords": [
            "Django 1.3",
            "Python",
            "MySQL",
            "HTML",
            "CSS",
            "jQuery",
            "Java Script",
            "Ajax"
        ],
        "description": "Fashion and media agencies, THE MODE Saas platform is used by world's top fashion and media agencies to manage their digital content."
    }
    
    
]